@for (shippingMethod of shippingMethods(); track shippingMethod) {
  {{ shippingMethod | translate }}<!---->
  @if (!$last) {
    <!---->, <br />
  }
} @empty {
  @if (type() === 'document') {
    {{ 'labels.notRequired' | translate }}
  } @else {
    -
  }
}
